const slug = (s) => String(s || 'na').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'na';

// rows: DB-shaped expense items. Returns Array<Array> for utils/csv.js toCsv().
export function buildExpenseCsvRows(rows) {
  const ordered = [...(rows || [])].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
  const total = ordered.reduce((s, r) => s + (Number.isFinite(Number(r.amount)) ? Number(r.amount) : 0), 0);
  return [
    ['Item', 'Link', 'Amount (USD)'],
    ...ordered.map((r) => [r.item ?? '', r.link ?? '', Number(r.amount)]),
    ['Total', '', total],
  ];
}

export function expenseCsvFilename(submission) {
  return `expenses-${slug(submission?.submitter?.name)}-${slug(submission?.period)}.csv`;
}
